import { combineReducers } from 'redux';

import data from './ProjectsData/ProjectsDataReducer';
import list from './ProjectsList/ProjectsListReducer';

export default combineReducers({ list, data });
